export default __webpack_public_path__ + "static/media/Aircraft5-t.59e0eb1e.png";